import CommonModal from "../shared/modalLayout/CommonModal";
import { useGetVaAudiologistSkusQuery } from "../../app/vaApi/vaApi";
import CaptifyProImage from "../../images/captify_myvu_product_audiologistic.png";
import CaptifyMyvuImage from "../../images/captify_pro_product_audiologistic.png";
import "../../styles/selectSkuModal.css";

/** Fallback images when Shopify product has no featured image. */
const FALLBACK_IMAGES = {
  CAP1: CaptifyProImage,
  CAP3: CaptifyMyvuImage,
  CAPTIFYPRO: CaptifyProImage,
  CAPTIFYMYVU: CaptifyMyvuImage,
};

function resolveSkuImage(sku) {
  if (sku?.imageUrl) return sku.imageUrl;
  const key = String(sku?.code || "")
    .trim()
    .toUpperCase()
    .replace(/[-\s]/g, "");
  return FALLBACK_IMAGES[key] || CaptifyProImage;
}

function formatSkuPrice(price) {
  if (price == null || Number.isNaN(Number(price))) return null;
  const value = Number(price);
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}

export default function SelectSkuModal({ show, onClose, onSelect }) {
  const { data: skus = [], isLoading, isError, refetch } =
    useGetVaAudiologistSkusQuery(undefined, { skip: !show });

  return (
    <CommonModal
      show={show}
      setShow={(open) => {
        if (!open) onClose();
      }}
      title="Select the SKU"
      centered
      className="select-sku-modal modal-md"
      onHide={onClose}
      closeOnBackdrop={false}
    >
      {isLoading && (
        <p className="text-center text-muted mb-0 py-4">Loading products…</p>
      )}

      {!isLoading && isError && (
        <div className="text-center py-4">
          <p className="text-danger mb-2">Could not load SKUs from Shopify.</p>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={refetch}>
            Retry
          </button>
        </div>
      )}

      {!isLoading && !isError && skus.length === 0 && (
        <p className="text-center text-muted mb-0 py-4">No SKUs available.</p>
      )}

      {!isLoading && !isError && skus.length > 0 && (
        <div
          className={`select-sku-grid${
            skus.length === 1 ? " select-sku-grid--single" : ""
          }`}
        >
          {skus.map((sku) => {
            const priceLabel = formatSkuPrice(sku.price);
            const isSolo = skus.length === 1;
            return (
              <button
                key={sku.productId || sku.code}
                type="button"
                className={`select-sku-card${
                  isSolo ? " select-sku-card--solo" : ""
                }`}
                onClick={() => onSelect(sku.code, sku)}
              >
                <div className="select-sku-card__image">
                  <img
                    src={resolveSkuImage(sku)}
                    alt={sku.imageAlt || sku.label}
                  />
                </div>
                <div className="select-sku-card__body">
                  {isSolo ? (
                    <span className="select-sku-card__eyebrow">Available SKU</span>
                  ) : null}
                  <div className="select-sku-card__label">{sku.label}</div>
                  {sku.code ? (
                    <div className="select-sku-card__code">{sku.code}</div>
                  ) : null}
                  {priceLabel != null && (
                    <div className="select-sku-card__price">${priceLabel}</div>
                  )}
                  {isSolo ? (
                    <span className="select-sku-card__cta">Continue with this SKU</span>
                  ) : null}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </CommonModal>
  );
}
